import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Packages
import shortid from 'shortid';

class ReduxSelectFormInput extends Component {
  static propTypes = {
    // From Redux Form:
    // { input, label, type, meta: { touched, error } }

    // Required
    input: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
    selectOptions: PropTypes.array.isRequired,

    //Optional
    label: PropTypes.string,
    error: PropTypes.string,
    meta: PropTypes.object,
    handleInputRemoval: PropTypes.func,
    optionalClasses: PropTypes.string,
    placeholder: PropTypes.string,
  }

  renderLabel(label) {
    const { disabled } = this.props;

    return label
    ? (
        <label className={disabled ? 'disabled' : null}>
          {label}
        </label>
      )
    : ''
  }

  handleRemoveButtonClick = (event) => {
    event.preventDefault();
    this.props.handleInputRemoval();
  }

  renderRemoveButton() {
    const { handleInputRemoval } = this.props;

    return handleInputRemoval
    ? (
      <a className="input-delete-button" onClick={(event)=> this.handleRemoveButtonClick(event)}>
        <svg className="icon"><use xlinkHref="#trash-can" /></svg>
      </a>
    ) : null
  }

  render() {
    const { input, label, type, meta: { touched, error } } = this.props
    const { optionalClasses, handleInputRemoval, selectOptions, placeholder } = this.props

    return (
      <div
        className={`input-container select-container${optionalClasses ? ' ' + optionalClasses : ''}${touched && error ? ' error' : ''}${handleInputRemoval ? ' removable' : ''}`}
      >
        {this.renderLabel(label)}
        <div className="input-container-inner">
          <div className="select-input-container">
            <select {...input} type={type} placeholder={label} >
              {
                placeholder &&
                <option value="" disabled defaultValue>
                  {placeholder}
                </option>
              }
              {selectOptions.map((option) => {
                return (
                  <option key={shortid.generate()} value={option.value}>
                    {option.label}
                  </option>
                );
              })}
            </select>
          </div>
          {this.renderRemoveButton()}
        </div>
        {touched && error &&
          <div className="input-error-message">
            {error}
          </div>
        }
      </div>
    )
  }
}


export default ReduxSelectFormInput;



// WEBPACK FOOTER //
// ./src/components/Global/ReduxForms/ReduxSelectFormInput.js